module.exports = __webpack_public_path__ + "static/media/loading.41712b70.png";